export const getFlagUrl = (flag) => {
  if (!flag) return '';
  if (flag.startsWith('http://') || flag.startsWith('https://')) return flag;
  const baseUrl = process.env.REACT_APP_UMBRACO || 'https://admin.eahs.ae';
  if (flag.startsWith('/Shared')) return `${baseUrl}${flag}`;
  if (flag.startsWith('/flags')) return `${baseUrl}/Shared${flag}`;
  if (flag.startsWith('flags/')) return `${baseUrl}/Shared/${flag}`;
  return `${baseUrl}/Shared/flags/${flag}`;
};

export default getFlagUrl;
